import styled from 'styled-components';
import { Cell } from './Cell';

export const TableHead = styled.thead`
  ${Cell} {
    font-weight: 700;
    padding-bottom: 0;
  }
`;
